module.exports = __webpack_public_path__ + "static/media/bj2.53e5951.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/bj2.mp3
// module id = tg/Q
// module chunks = 89